import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { startStampsAccountVerification } from '../../store/seller/seller.actions';
import { Button } from 'ui-components/components/button';
import messages from './messages';
import style from './style.module.less';
import classNames from 'classnames';

const PhoneVerificationRequiredMessage = ({ sellerProviderId, useSmallerFontSize }) => {
  const dispatch = useDispatch();
  const onPhoneVerifyLinkClick = useCallback(() => {
    dispatch(
      startStampsAccountVerification({
        sellerProviderId,
        // TODO: add an existing phone number from their account
        mustUsePhoneNumberProvided: false,
        phoneNumber: '',
      }),
    );
  }, [dispatch, sellerProviderId]);

  return (
    <FormattedMessage
      {...messages.walletPhoneVerificationRequired}
      values={{
        b: (chunks) => {
          return (
            <Button
              className={classNames(style['phone-verify-link'], {
                [style.small]: useSmallerFontSize,
              })}
              onClick={onPhoneVerifyLinkClick}
              theme='link'
            >
              {chunks}
            </Button>
          );
        },
      }}
    />
  );
};

PhoneVerificationRequiredMessage.propTypes = {
  sellerProviderId: PropTypes.string.isRequired,
  useSmallerFontSize: PropTypes.bool.isRequired,
};

export default PhoneVerificationRequiredMessage;
